import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BEBiomedicalCoursePage: React.FC = () => {
  const courseData = {
    title: "B.E. Biomedical Engineering",
    shortName: "B.E. Biomedical",
    duration: "4 years",
    description: "Interdisciplinary engineering program combining engineering principles with biological and medical sciences",
    overview: "Bachelor of Engineering in Biomedical Engineering (B.E. Biomedical) is a 4-year undergraduate program that integrates engineering principles with biological and medical sciences. This course covers medical instrumentation, biomaterials, prosthetics, medical imaging, and healthcare technology to develop solutions for medical and healthcare challenges.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics",
      "Biology/Biotechnology preferred but not mandatory",
      "Minimum 75% marks in JEE Main (50% for SC/ST)",
      "Valid JEE Main/State CET scores"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Mathematics-I & II",
          "Physics",
          "Chemistry",
          "Biology for Engineers",
          "Engineering Graphics",
          "Introduction to Biomedical Engineering"
        ]
      },
      {
        year: 2,
        subjects: [
          "Human Anatomy and Physiology",
          "Electronic Devices and Circuits",
          "Materials Science",
          "Biomechanics",
          "Cell Biology and Biochemistry",
          "Medical Instrumentation"
        ]
      },
      {
        year: 3,
        subjects: [
          "Medical Imaging Systems",
          "Biomaterials and Tissue Engineering",
          "Biomedical Signal Processing",
          "Prosthetics and Rehabilitation Engineering",
          "Clinical Engineering",
          "Biomedical Sensors"
        ]
      },
      {
        year: 4,
        subjects: [
          "Medical Device Design",
          "Biomedical Informatics",
          "Regulatory Affairs in Healthcare",
          "Artificial Organs",
          "Project Work",
          "Hospital Internship"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Biomedical Engineer",
        "Clinical Engineer",
        "Medical Device Designer",
        "Quality Assurance Engineer",
        "Regulatory Affairs Specialist",
        "Research Scientist",
        "Application Engineer",
        "Technical Sales Engineer",
        "Healthcare Technology Consultant",
        "Medical Equipment Service Engineer"
      ],
      industries: [
        "Medical Device Manufacturing",
        "Hospitals and Healthcare Systems",
        "Pharmaceutical Companies",
        "Biotechnology Firms",
        "Research Institutions",
        "Government Health Organizations",
        "Medical Imaging Companies",
        "Prosthetics and Rehabilitation",
        "Healthcare IT",
        "Regulatory Bodies"
      ],
      averageSalary: "₹6-12 LPA (Fresher), ₹20-50 LPA (Experienced)",
      topRecruiters: [
        "Siemens Healthineers, GE Healthcare",
        "Philips Healthcare, Medtronic",
        "Johnson & Johnson, Abbott",
        "Tata Medical & Diagnostics",
        "BPL Medical Technologies",
        "Apollo Hospitals, Fortis Healthcare"
      ]
    },

    admissionProcess: [
      "TNEA Counselling (for Tamil Nadu colleges)",
      "JEE Main (for NITs and central universities)",
      "State-level entrance exams",
      "Management quota admissions",
      "Direct admission based on 12th marks"
    ],

    topColleges: [
      {
        name: "SSN College of Engineering",
        location: "Chennai",
        fees: "₹4,20,000",
        ranking: "NAAC A+ Grade"
      },
      {
        name: "VIT University",
        location: "Vellore",
        fees: "₹7,83,000",
        ranking: "NIRF Ranking: 15"
      },
      {
        name: "SRM Institute of Science and Technology",
        location: "Chennai",
        fees: "₹12,00,000",
        ranking: "NIRF Ranking: 41"
      },
      {
        name: "Rajalakshmi Engineering College",
        location: "Chennai",
        fees: "₹3,00,000",
        ranking: "NAAC A+ Grade"
      }
    ],

    skills: [
      "Medical Device Design",
      "MATLAB/Simulink",
      "CAD Software (SolidWorks, AutoCAD)",
      "Signal Processing",
      "Biomaterials Knowledge",
      "Regulatory Standards (FDA, ISO)",
      "Programming (C, Python)",
      "Medical Imaging Software",
      "Project Management",
      "Clinical Research Methods"
    ],

    futureScope: "Excellent growth potential with aging population, healthcare digitization, telemedicine, AI in healthcare, and increasing focus on medical innovation and accessibility.",

    faqs: [
      {
        question: "Do I need a biology background for Biomedical Engineering?",
        answer: "While helpful, biology background is not mandatory. The curriculum includes necessary biology and medical science courses for engineering students."
      },
      {
        question: "Can I work in hospitals?",
        answer: "Yes, as a Clinical Engineer managing medical equipment, technology systems, and collaborating with healthcare professionals on equipment selection and maintenance."
      },
      {
        question: "What about research opportunities?",
        answer: "Excellent research opportunities in areas like artificial organs, medical robotics, drug delivery systems, and regenerative medicine at universities and research institutes."
      },
      {
        question: "Is this field suitable for entrepreneurship?",
        answer: "Yes, many opportunities exist for developing innovative medical devices, healthcare apps, and solutions for Indian healthcare challenges."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BEBiomedicalCoursePage;
